import SideLayout from './SideLayout';
import SingleLayout from './SingleLayout';
import SwipeLayout from './SwipeLayout';

export { SingleLayout, SideLayout, SwipeLayout };
